export const savedCartQueryKeys = {
    all: ['savedCarts'],
    productsForSavedCart: (id: string, storeId: string, productIds: string[]) => [
        ...savedCartQueryKeys.all,
        'products',
        {
            cartId: id,
            storeId,
            productIds,
        },
    ],
    byPaging: (page: number, pageSize: number) => [...savedCartQueryKeys.all, page, pageSize],
};

export const subscriptionsQueryKeys = {
    all: ['subscriptions'],
    byId: (id: string) => [...subscriptionsQueryKeys.all, id],
    timeslots: (subId: string) => [...subscriptionsQueryKeys.all, 'subscriptionTimeslots', subId],
    klarnaSnippet: ['subscriptionsKlarnaSnippet'],
};

export const orderReclamationsQueryKey = ['orderReclamations'];
export const orderReturnsQueryKey = ['orderReturns'];
export const deliveryAddressQueryKey = ['deliveryAddress'];
export const connectedCardsQueryKey = ['connectedCards'];

export const lastOrdersQueryKeys = {
    all: ['lastOrders'],
    byId: (id: string | undefined) => [
        ...lastOrdersQueryKeys.all,
        {
            orderId: id,
        },
    ],
    byIdWithOrderStoreProducts: (id: string | undefined) => [
        ...lastOrdersQueryKeys.all,
        {
            orderId: id,
            withOrderStoreProducts: true,
        },
    ],
    byIdWithStoreProducts: (id: string | undefined, storeId: string) => [
        ...lastOrdersQueryKeys.all,
        {
            orderId: id,
            storeId,
        },
    ],
};

export const myCoopProfileMenuKeys = {
    all: ['myCoopProfileMenu'],
    settingsPage: ['myCoopSettingsPage'],
};

export const myCoopHouseholdKeys = {
    householdMembers: ['householdMembers'],
};

export const associationNamesQueryKey = ['associationNames'];
export const engagementsQueryKey = ['engagements'];
export const matkontoBalanceQueryKey = ['matkontoBalance'];

export const householdMemberQueryKeys = {
    addHouseholdMember: (personalNumber: string) => ['addHouseholdMember', personalNumber],
};

// Poänguttag - Pointitem purchases
export const pointItemWithdrawalHistoryKeys = {
    all: ['pointItemWithdrawalHistory'],
    byDate: (from: Date, to: Date, page: number, size: number) => [
        ...pointItemWithdrawalHistoryKeys.all,
        from,
        to,
        page,
        size,
    ],
    hasOldOnlineChecks: (from: Date, to: Date) => [
        ...pointItemWithdrawalHistoryKeys.all,
        'hasOldOnlineChecks',
        from,
        to,
    ],
};

// Poänghistorik - point history
export const pointHistoryKeys = {
    all: ['pointHistory'],
    infiniteByDate: (from: Date, size: number) => [...pointHistoryKeys.all, 'infinite', from, size],
    bonusInfiniteByDate: (from: Date, size: number) => [
        ...pointHistoryKeys.all,
        'bonus2026',
        'infinite',
        from,
        size,
    ],
};

// Köphistorik - Money purchase history
export const purchaseHistoryKeys = {
    all: ['purchaseHistory'],
    byDate: (from: Date, page: number, size: number) => [
        ...purchaseHistoryKeys.all,
        from,
        page,
        size,
    ],
};

export const consentSubscriptionsKeys = {
    all: ['consentSubscriptions'],
    consentSubscriptionsByBeId: (beId: string) => [...consentSubscriptionsKeys.all, beId],
    consentSubscriptionsByNeoId: (neoId: string) => [...consentSubscriptionsKeys.all, neoId],
    consentSubscriptionsByAppViewToken: (AppViewToken: string) => [
        ...consentSubscriptionsKeys.all,
        AppViewToken,
    ],
    consentSubscriptionsByMmId: (mmId: string) => [...consentSubscriptionsKeys.all, mmId],
    consentSubscriptionsByEmail: (email: string) => [...consentSubscriptionsKeys.all, email],
};

export const consentSubscribeToggleKeys = {
    consentSubscribeByNeoId: (neoId: string) => ['consentSubscribeNeo', neoId],
    consentSubscribeByMmId: (mmId: string) => ['consentSubscribe', mmId],
    consentUnsubscribeByNeoId: (neoId: string) => ['consentUnsubscribeNeo', neoId],
    consentUnsubscribeByMmId: (mmId: string) => ['consentUnsubscribe', mmId],
};
